"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebPSupportCheck = void 0;
const react_1 = require("react");
const supports_webp_1 = __importDefault(require("supports-webp"));
function useWebPSupportCheck() {
    const [{ webP: supportsWebP }, setWebPSupport] = react_1.useState({ webP: false });
    react_1.useEffect(() => {
        // eslint-disable-next-line unicorn/consistent-function-scoping
        const checkForSupport = async () => {
            const browserSupportsWebP = await supports_webp_1.default;
            setWebPSupport({ webP: browserSupportsWebP });
        };
        checkForSupport();
    }, [supports_webp_1.default]);
    return supportsWebP;
}
exports.useWebPSupportCheck = useWebPSupportCheck;
//# sourceMappingURL=index.js.map